import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { EbookMockup } from './EbookMockup';
export function ProductPresentation() {
  const benefits = ['40 recetas divididas en Desayunos, Almuerzos, Snacks y Cenas para que nunca te falte idea de qué cocinar.', 'Cada receta lista en menos de 20 minutos, metés los ingredientes, elegís el tiempo y listo. Sin complicarte.', '100% ingredientes del súper o del almacén de tu barrio. Nada importado, nada de dietética.', 'Para principiantes, sin jerga nutricional, sin apps, sin macros complicados.', 'Ebook descargable instantáneamente, lo tenés en tu celular en segundos. También versión para imprimir y pegar en la heladera.'];
  return <section className="py-16 px-4 md:py-24 bg-[#F5F5F5]" data-id="element-243">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-245">
          <h2 className="font-heading font-bold text-xl text-gray-800 mb-2" data-id="element-246">
            Por eso te presentamos…
          </h2>
          <h3 className="font-heading font-bold text-2xl md:text-4xl text-gray-900 mb-6" data-id="element-247">
            40 Recetas Keto en Air Fryer{' '}
            <span className="text-[#00A86B]" data-id="element-248">para Principiantes</span>
          </h3>
          <p className="text-gray-600 text-base md:text-lg mb-10 max-w-2xl mx-auto" data-id="element-249">
            El recetario digital pensado para personas reales, con poco tiempo,
            que quieren empezar keto de forma fácil, rica y sostenible.
          </p>

          <div className="mb-12" data-id="element-250">
            <EbookMockup className="scale-110" data-id="element-251" />
          </div>

          <div className="text-left space-y-4 max-w-2xl mx-auto bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-orange-50" data-id="element-252">
            {benefits.map((text, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-253">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#00A86B] flex items-center justify-center mt-0.5" data-id="element-254">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-255" />
                </div>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-256">
                  {text}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}